var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -1055) translate(75 1055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.25,
    stroke: "#777",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M20.5 23L13 16 15.5 14 22 21.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchBlack);
export default __webpack_public_path__ + "static/media/ic_search_black.fb58ac4082d1014fd33195bdf8e922d1.svg";
export { ForwardRef as ReactComponent };